var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAccountPerConsumer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#619BF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0312 16.1245C25.29 16.1245 25.5 15.9145 25.5 15.6558V14.7183C25.5 14.5448 25.4044 14.3864 25.2516 14.3048L18.2203 10.5548C18.0825 10.4817 17.9175 10.4817 17.7797 10.5548L10.7484 14.3048C10.5956 14.3864 10.5 14.5448 10.5 14.7183V15.6558C10.5 15.9145 10.71 16.1245 10.9688 16.1245H12.375V23.6245H11.1253C10.7794 23.6245 10.5 23.9039 10.5 24.2498V24.8752C10.5 25.2202 10.7794 25.4995 11.1253 25.4995H24.8756C25.2206 25.4995 25.5 25.2202 25.5 24.8742V24.2489C25.5 23.9039 25.2206 23.6245 24.8747 23.6245H23.625V16.1245H25.0312ZM22.3753 23.6245H13.6256V16.1245H22.3753V23.6245Z",
    fill: "#DFEBFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7628 20.3434H18.2381C18.4518 20.3434 18.6253 20.5178 18.6253 20.7372C18.6253 20.9509 18.4509 21.1244 18.2381 21.1244H16.9068C16.6481 21.1244 16.4381 21.3344 16.4381 21.5931C16.4381 21.8519 16.6481 22.0619 16.9068 22.0619H17.5312V22.5306C17.5312 22.7894 17.7412 22.9994 17.9999 22.9994C18.2587 22.9994 18.4687 22.7894 18.4687 22.5306V22.0384C19.0893 21.9278 19.5628 21.3878 19.5628 20.7306C19.5628 20.0003 18.9684 19.4059 18.2381 19.4059H17.7628C17.549 19.4059 17.3756 19.2316 17.3756 19.0122C17.3756 18.7984 17.5499 18.625 17.7628 18.625H19.094C19.3528 18.625 19.5628 18.415 19.5628 18.1562C19.5628 17.8975 19.3528 17.6875 19.094 17.6875H18.4687V17.2188C18.4687 16.96 18.2587 16.75 17.9999 16.75C17.7412 16.75 17.5312 16.96 17.5312 17.2188V17.7109C16.9106 17.8216 16.4371 18.3616 16.4371 19.0188C16.4371 19.7491 17.0315 20.3434 17.7628 20.3434Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAccountPerConsumer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-account-per-consumer.62c421d95d5e53555df91784dbc0f9d7.svg";